import { render, staticRenderFns } from "./TalentScores.vue?vue&type=template&id=61a6354e&scoped=true&"
import script from "./TalentScores.vue?vue&type=script&lang=js&"
export * from "./TalentScores.vue?vue&type=script&lang=js&"
import style0 from "./TalentScores.vue?vue&type=style&index=0&id=61a6354e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6354e",
  null
  
)

export default component.exports